<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters cols="12" class="my-3 justify-center">
            <v-col cols="4" class="d-flex justify-center">
                <v-select
                    v-if="mode === 'displayOnly'"
                    outlined
                    :items="allAuditCheckTypes"
                    item-title="title"
                    item-value="value"
                    v-model="auditCheckType"
                    hide-details
                    label="Sélectionner un type de contrôle"
                    :full-width="false"
                    item-density="compact"
                >
                </v-select>
                <v-select-filled
                    v-else
                    outlined
                    :items="allAuditCheckTypes"
                    item-title="title"
                    item-value="value"
                    v-model="auditCheckType"
                    hide-details
                    label="Sélectionner un type de contrôle"
                    :full-width="false"
                    item-density="compact"
                >
                </v-select-filled>
            </v-col>
            <v-col cols="4" class="pl-2">
                <v-text-field
                    v-if="mode === 'displayOnly'"
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details
                    density="compact"
                    clearable
                    @click:clear="onClearSearch"
                    append-inner-icon="$search"
                />
                <v-text-field-filled
                    v-else
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details
                    density="compact"
                    clearable
                    @click:clear="onClearSearch"
                    append-inner-icon="$search"
                />
            </v-col>
            <v-col cols="2" class="d-flex justify-center" v-if="mode === 'displayOnly'">
                <!-- <v-col cols="2" class="d-flex justify-center"> -->
                <!-- <h1 style="height:40px">{{`${auditCheckType ? items.length : auditCheckCount} contrôles`}}</h1> -->
                <h1 style="height: 40px">{{ items.length }} contrôles</h1>
            </v-col>
            <!-- <v-col cols="2" class="pl-2 d-flex justify-center" v-if="mode === 'displayOnly'">
                <v-btn
                    icon
                    elevation="0"
                    @click="update()"
                    :loading="updateLoading"
                    color="primary"
                >
                    <v-icon>$fa-sync-alt</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row no-gutters>
            <v-col
                cols="12"
                style="overflow-y: auto; height: calc(100vh - 260px)"
                id="auditChecks-list"
            >
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="8">
                        <div class="d-flex justify-center mt-5">
                            <v-list lines="three" style="background: transparent">
                                <v-list-item
                                    v-for="item of items"
                                    class="oss-list-item mb-1 pa-0"
                                    :key="item.key"
                                    style="width: 40vw"
                                    @click="displayExistingAudit(item)"
                                    :disabled="isAuditAlreadySelected(item.key)"
                                    :model-value="item"
                                >
                                    <v-row no-gutters>
                                        <v-col cols="2" class="d-flex justify-center align-center">
                                            <v-icon
                                                :icon="auditCheckIcon(item.type)"
                                                :color="auditCheckColor(item)"
                                                size="large"
                                                class="ma-1"
                                            />
                                        </v-col>
                                        <v-col cols="10">
                                            <!-- <v-list-item-title class="text-wrap" v-text="index"></v-list-item-title> -->
                                            <v-list-item-title class="text-wrap">{{
                                                item.title
                                            }}</v-list-item-title>
                                            <v-list-item-subtitle
                                                :class="
                                                    isAuditAlreadySelected(item.key)
                                                        ? 'text--secondary my-2 text-wrap'
                                                        : 'text--primary my-2 text-wrap'
                                                "
                                                v-text="
                                                    $t('audit.accessRight.' + item.accessRight) +
                                                    ' - ' +
                                                    $t('audit.status.' + item.status)
                                                "
                                            />
                                            <v-list-item-subtitle
                                                class="text--primary my-2 text-wrap"
                                                v-if="isAuditAlreadySelected(item.key)"
                                                ><strong>
                                                    Ce contrôle est déjà présent dans ce dossier de
                                                    révision
                                                </strong>
                                            </v-list-item-subtitle>
                                        </v-col>
                                    </v-row>
                                    <template
                                        v-slot:append
                                        v-if="
                                            mode === 'displayOrSelect' &&
                                            !isAuditAlreadySelected(item.key)
                                        "
                                    >
                                        <div class="d-flex justify-center">
                                            <div class="pr-2">
                                                <v-icon> $oss-chevron-right </v-icon>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-slot:append v-else-if="mode === 'enableActions'">
                                        <div class="d-flex justify-center">
                                            <div class="pr-2" v-if="mode === 'enableActions'">
                                                <v-btn-trash
                                                    v-if="
                                                        item.type ===
                                                        'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                                                    "
                                                    @click.stop="
                                                        toggleDeleteAuditCheckDialog();
                                                        selectItemToDelete(item.id);
                                                    "
                                                    :disabled="
                                                        item.accountingReviewLayouts.length > 0
                                                    "
                                                    size="small"
                                                />
                                                <v-icon> $oss-chevron-right </v-icon>
                                            </div>
                                        </div>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <!-- <v-col cols ="2"></v-col> -->
            <oss-dialog
                v-model="deleteAuditCheckDialog"
                v-if="deleteAuditCheckDialog"
                title="Souhaitez-vous vraiment supprimer ce contrôle ?"
                validTitle="Supprimer"
                :error="true"
                @valid="deleteAuditCheck(itemToDelete)"
                @close="resetItemToDelete()"
                width="1000px"
            >
            </oss-dialog>
            <!-- <v-col cols ="2"></v-col>
            <v-col cols="8" v-intersect="onIntersectNext" v-if="auditCheckCount > items.length" class="d-flex align-center justify-center">
                <v-card class="default_card" elevation="0" pa-0 style="margin: 5px; width:40vw;">
                    <v-row class="d-flex align-center justify-center">
                        <v-col cols="2">
                            <v-skeleton-loader
                                type="avatar"
                            ></v-skeleton-loader>
                        </v-col>
                        <v-col cols="9">
                            <v-skeleton-loader
                            type="heading"
                            class="my-3"
                        ></v-skeleton-loader>
                        <v-skeleton-loader
                            type="text"
                            class="my-auto"
                        ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols ="2"></v-col> -->
        </v-row>
    </v-container>
</template>
<script lang="ts">
import colors from "vuetify/lib/util/colors";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";

import AUDIT_CHECKS from "../../graphql/audit/auditChecks.gql";
import UPDATE_AUDIT_CHECKS from "../../graphql/audit/updateAuditChecks.gql";
import DELETE_AUDIT_CHECK from "../../graphql/audit/DeleteAuditCheck.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["displayExistingAudit"],
})
export class AuditChecks extends Vue {
    @Prop({ default: "displayOnly" }) mode: string;
    @Prop({
        type: Array,
        default: function () {
            return ["INFORM", "ACTION", "WARNING", "ERROR"];
        },
    })
    auditCheckTypes: Array<string>;
    @Prop({
        type: Array,
        default: function () {
            return [];
        },
    })
    alreadySelectedAudits: Array<any>;

    firstRequestDone = false;

    loadingStateNext = true;

    loadingStateNextInQuery = true;

    updateLoading = false;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    isScrollSubscribe: boolean = false;

    auditCheckType = "ALL";

    search = "";

    index = 0;

    displayAuditDialog: boolean = false;

    auditCheckEditionDialogStep: string = "createAudit";

    auditToDisplay: any = null;

    deleteAuditCheckDialog: boolean = false;

    itemToDelete: string = "";

    checkTypeIcons = {
        header: "",
        INFORM: "$bell",
        ACTION: "$bell",
        WARNING: "$bell_alert",
        ERROR: "$alert",
    };

    checkTypeColors = {
        header: "",
        INFORM: "green",
        ACTION: "blue",
        WARNING: "orange",
        ERROR: "red",
    };

    auditCheckTypesDico = {
        ALL: "Tous les contrôles",
        INFORM: "Information",
        ACTION: "Action",
        WARNING: "Avertissement",
        ERROR: "Erreur",
        ACCOUNTING_REVIEW_AUTO: "Contrôles automatiques",
        ACCOUNTING_REVIEW_MANUAL: "Contrôles manuels",
        ACCOUNTING_REVIEW_MANUAL_CUSTOM: "Contrôles manuels personnalisés",
    };

    get allAuditCheckTypes() {
        const auditCheckTypes = ["ALL", ...this.auditCheckTypes];
        return auditCheckTypes.map((acType) => {
            return {
                title: this.auditCheckTypesDico[acType] || "Titre manquant",
                value: acType,
            };
        });
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        if (this.currentUser.company.accountingFirm) {
            return this.currentUser.company.id;
        }
        return;
    }

    @Apollo({
        query: AUDIT_CHECKS,
        variables() {
            this.loadingStateNextInQuery = this.loadingStateNext;
            return {
                // first: this.pagination.rowsPerPage,
                // skip: ((this.pagination.page - 1) * this.pagination.rowsPerPage),
                search: this.search,
                type: this.auditCheckType === "ALL" ? this.auditCheckTypes : [this.auditCheckType],
                accountingFirmId: this.accountingFirmId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.auditChecks) {
                    this.items = data.auditChecks.map(({ title, key, ...rest }) => {
                        return {
                            ...rest,
                            key,
                            title: title || this.$t(`audit.${key}.title`, 1),
                        };
                    });
                    // this.items = [];
                    // for (const ac of data.auditChecks) {
                    //     if (!ac.title) {
                    //         ac.title = this.$t(`audit.${ac.key}.title`, 1);
                    //     }
                    //     this.items.push(ac);
                    // }
                    this.firstRequestDone = true;
                    this.loadIntersectionObserver();
                }
            }
        },
    })
    items: Array<any> = [];

    auditCheckIcon(type) {
        return this.checkTypeIcons[type] || "$label";
    }

    auditCheckColor(item) {
        if (this.isAuditAlreadySelected(item.key)) {
            return "colors.grey";
        }
        const color = this.checkTypeColors[item.type] || "green";
        return color;
    }

    loadIntersectionObserver() {
        if (this.isScrollSubscribe) {
            return;
        }
        const listElm = document.querySelector("#auditChecks-list");
        listElm?.addEventListener("scroll", (e) => {
            if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 10) {
                this.onIntersectNext(true);
            }
        });
        this.isScrollSubscribe = true;
    }

    onIntersectNext(
        isIntersecting: boolean,
        entries: IntersectionObserverEntry[] = null,
        observer: IntersectionObserver = null,
    ) {
        if (this.firstRequestDone) {
            if (isIntersecting) {
                // this.loadingStateNext = true;
                this.pagination.page += 1;
            }
            // if (entries[0].isIntersecting) {
            //     // this.loadingStateNext = true
            //     this.pagination.page += 1;
            // }
        }
    }

    toggleDisplayAuditDialog() {
        return (this.displayAuditDialog = !this.displayAuditDialog);
    }

    toggleDeleteAuditCheckDialog() {
        return (this.deleteAuditCheckDialog = !this.deleteAuditCheckDialog);
    }

    displayExistingAudit(audit) {
        this.$emit("displayExistingAudit", audit);
    }

    selectItemToDelete(id) {
        this.itemToDelete = id;
    }

    resetItemToDelete() {
        this.itemToDelete = "";
    }

    async update() {
        this.updateLoading = true;
        await this.$apollo.mutate({
            mutation: UPDATE_AUDIT_CHECKS,
        });
        await this.refresh();
        this.updateLoading = false;
    }

    reset() {
        this.firstRequestDone = false;
        this.items = [];
        this.pagination.page = 1;
    }

    async refresh() {
        this.reset();
        if (this.$apollo.queries) {
            if (this.$apollo.queries.items) {
                this.$apollo.queries.items.refetch();
            }
        }
    }

    async deleteAuditCheck(id) {
        const result = await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK,
            variables: {
                id: id,
            },
        });
        if (result?.data) {
            this.items = this.items.filter((item) => item.id !== id);
            this.resetItemToDelete();
        }

        this.toggleDeleteAuditCheckDialog();
    }

    onClearSearch() {
        this.search = "";
    }

    isAuditAlreadySelected(key) {
        if (this.alreadySelectedAudits.find((audit) => audit.key === key)) {
            return true;
        }
    }
}

export default toNative(AuditChecks);
</script>

<style>
.icon {
    font-size: 40px;
    background-color: rgb(255, 255, 255);
    border-radius: 12px;
    padding: 10px;
}

.v-list-item-subtitle {
    line-clamp: none !important;
    -webkit-line-clamp: none !important;
}
</style>
